import React, { useState } from "react";
import Button from "components/Form/fields/Button";
import { getStripeOnboardAccountLink } from "utils/stripe";
import { useCtxReferences } from "utils/selectors";

const CompleteStripeConnect = ({
  account,
  theme,
  copy,
  merchantAccountUUID,
  resource,
  resourceUUID,
  classes
}) => {
  const [loading, setLoading] = useState(false);
  const {
    resource: ctxResource,
    resourceUUID: ctxResourceUUID
  } = useCtxReferences();

  const input = {
    account,
    merchantAccountUUID,
    resource: resource || ctxResource,
    resourceUUID: resourceUUID || ctxResourceUUID
  };

  return (
    <Button
      classes={classes}
      loading={loading}
      theme={theme}
      copy={copy || "Complete account"}
      onClick={async () => {
        setLoading(true);
        const acccountLink = await getStripeOnboardAccountLink(input);
        setLoading(false);

        window.location.href = acccountLink;
      }}
    ></Button>
  );
};

export default CompleteStripeConnect;
